import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { FiMenu } from 'react-icons/fi'
import { CgClose } from 'react-icons/cg'
import theme from '../../lib/theme'
import colors from '../../lib/colors'

const Styles = styled.div`
  cursor: pointer;
  height: ${theme.headerHeight};
  display: flex;
  align-items: center;
  svg {
    color: ${colors.white};
    width: 30px;
    height: auto;
  }
`
interface IMobileControlProps {
  menuCollapsed: boolean
  toggleMenu: () => void
}
export default function MobileControl(
  props: IMobileControlProps,
): ReactElement {
  const { menuCollapsed, toggleMenu } = props

  const renderIcon = menuCollapsed ? <FiMenu /> : <CgClose />

  return <Styles onClick={toggleMenu}>{renderIcon}</Styles>
}
